import * as React from 'react';
import { SVGProps } from 'react';

const IconMoonSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M21.874 13.593a7.5 7.5 0 0 1-9.481-11.586C12.263 2.004 12.132 2 12 2 6.477 2 2 6.477 2 12s4.477 10 10 10c4.98 0 9.11-3.641 9.874-8.407z" />
  </svg>
);
export default IconMoonSizeM;
